import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IconButton from '@material-ui/core/IconButton';
import AddCircleIcon from '@material-ui/icons/AddCircleOutline';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { ActiveStatus } from '../../../components';
import { COLORS, getVariantPrice, PRICE_LEVELS, toCurrency } from '../../../helpers';
import EmptyImage from '../assets/no.jpg';

const propTypes = {
  onUpdateVariant: PropTypes.func.isRequired,
  onCreateVariant: PropTypes.func.isRequired,
  variants: PropTypes.array,
};

const styles = {
  wrapper: {
    width: '100%',
    borderTop: '1px solid ' + COLORS.border,
    padding: '20px 25px 5px',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 5,
    paddingBottom: 5,
    justifyContent: 'space-between',
  },
  title: {
    color: COLORS.cartSecondary,
    fontSize: '12px',
  },
  button: {
    padding: 0,
  },
  icon: {
    color: COLORS.text,
  },
  variant: {
    display: 'flex',
    flexDirection: 'row',
    borderTop: '1px solid' + COLORS.border,
    padding: '5px 0 10px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    borderTop: '1px solid' + COLORS.border,
    padding: '10px 0 10px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cell: {
    flex: 2,
    fontSize: '14px',
    color: COLORS.text,
    fontFamily: 'Roboto',
    marginRight: 5,
    textAlign: 'center',
  },
  image: {
    height: 40,
  },
};

const getImage = (variant) => {
  if (variant.image && variant.image.src) {
    return variant.image.src;
  }
  if (variant.image && !variant.image.src) {
    return `data:image/png;base64,${variant.image}`;
  }
  return EmptyImage;
};

const getPrice = (variant, intl, level) => {
  if (variant[`price.${level}`]) {
    return toCurrency(variant[`price.${level}`], intl).toString();
  }

  if (variant.prices) {
    return getVariantPrice(variant, intl, level);
  }

  return 0;
};

const Variants = ({ intl, classes, variants, onUpdateVariant, onCreateVariant }) => {
  return (
    <Paper className={classes.wrapper} elevation={1}>
      <div className={classes.header}>
        <Typography className={classes.title}>{intl.formatMessage({ id: 'global.variants' })}</Typography>

        <IconButton className={classes.button} onClick={onCreateVariant}>
          <AddCircleIcon className={classes.icon} />
        </IconButton>
      </div>

      {!!variants.length && (
        <div className={classes.headerRow}>
          <div style={{ textAlign: 'left' }} className={classes.cell}>
            {intl.formatMessage({ id: 'global.image' })}
          </div>
          <div className={classes.cell}>{intl.formatMessage({ id: 'global.name' })}</div>
          <div className={classes.cell}>{intl.formatMessage({ id: 'global.unit' })}</div>
          <div className={classes.cell}>{intl.formatMessage({ id: 'products.column.retailMarket' })}</div>
          <div className={classes.cell}>{intl.formatMessage({ id: 'products.column.retailPreorder' })}</div>
          <div className={classes.cell}>{intl.formatMessage({ id: 'products.column.wholesaleMarket' })}</div>
          <div className={classes.cell}>{intl.formatMessage({ id: 'products.column.wholesalePreorder' })}</div>
          <div style={{ flex: 1 }} className={classes.cell}>
            {intl.formatMessage({ id: 'products.column.active' })}
          </div>
          <div style={{ textAlign: 'right', flex: 1 }} className={classes.cell}>
            {intl.formatMessage({ id: 'global.actions' })}
          </div>
        </div>
      )}

      {variants.map((variant) => (
        <div key={variant.id} className={classes.variant}>
          <div style={{ textAlign: 'left' }} className={classes.cell}>
            <img className={classes.image} alt={'Line item'} src={getImage(variant)} />
          </div>
          <div className={classes.cell}>{variant?.name || ''}</div>
          <div className={classes.cell}>{variant.unit}</div>
          <div className={classes.cell}>{getPrice(variant, intl, PRICE_LEVELS.RETAIL_MARKET)}</div>
          <div className={classes.cell}>{getPrice(variant, intl, PRICE_LEVELS.RETAIL_PREORDER)}</div>
          <div className={classes.cell}>{getPrice(variant, intl, PRICE_LEVELS.WHOLESALE_MARKET)}</div>
          <div className={classes.cell}>{getPrice(variant, intl, PRICE_LEVELS.WHOLESALE_PREORDER)}</div>
          <div style={{ flex: 1 }} className={classes.cell}>
            <ActiveStatus status={variant.active} />
          </div>
          <div style={{ textAlign: 'right', flex: 1 }} className={classes.cell}>
            <IconButton className={classes.button} onClick={() => onUpdateVariant(variant)}>
              <KeyboardArrowRightIcon className={classes.icon} />
            </IconButton>
          </div>
        </div>
      ))}
    </Paper>
  );
};

Variants.propTypes = propTypes;

export default withStyles(styles)(injectIntl(Variants));
